import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=4618d203&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"
import style0 from "./premium.vue?vue&type=style&index=0&id=4618d203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618d203",
  null
  
)

export default component.exports